import { FC } from 'react'

import {
  Control,
  Controller,
  FieldArrayWithId,
  FieldError,
  FieldErrors,
} from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Paper } from 'shared/ui/paper'
import { Select } from 'shared/ui/select'
import { SelectMulti } from 'shared/ui/select-multi'
import { Option } from 'shared/ui/select/select'
import { TextArea } from 'shared/ui/text-area'
import UploadFiles from 'shared/ui/upload-files'

import { IAdditionalServiceForm } from '../../appeal-form-service'

import s from './styles.module.scss'

interface Props {
  id?: string
  index: number
  onDelete?: () => void
  listPassengers?: Option[]
  listService?: Option[]
  control: Control<IAdditionalServiceForm>
  errors: FieldErrors<IAdditionalServiceForm>
  passenger: FieldArrayWithId<IAdditionalServiceForm>
}

const SelectServiceForPassengers: FC<Props> = ({
  id,
  index,
  errors,
  control,
  onDelete,
  listService,
  listPassengers,
}) => {
  const { t } = useTranslation()

  return (
    <Paper padding={[16]}>
      <div className={s.container}>
        <div className={s.header}>
          <p>
            {t('service_each')} №{index + 1 || 1}{' '}
          </p>

          {index > 0 && (
            <p
              className={s.delete}
              onClick={onDelete}
            >
              {t('delete')}
            </p>
          )}
        </div>

        <div className={s.item}>
          <Controller
            key={id}
            control={control}
            rules={{ required: true }}
            name={`forms.${index}.topic`}
            render={({ field }) => (
              <Select
                options={listService}
                error={errors.forms?.[index]?.topic}
                onChange={(option) => field.onChange(option.value)}
                placeholder={t('additional_service.select_services')}
              />
            )}
          />
        </div>

        <div className={s.itemWhite}>
          <Controller
            key={id}
            control={control}
            rules={{ required: true }}
            name={`forms.${index}.passengers`}
            render={({ field }) => (
              <SelectMulti
                title={t('select_passengers_multi')}
                options={listPassengers || []}
                error={errors?.forms?.[index]?.passengers && true}
                onChange={(value) => field.onChange(value)}
                placeholder={t('additional_service.select_passenger') + '*'}
              />
            )}
          />
        </div>

        <div className={s.item}>
          <Controller
            key={id}
            control={control}
            rules={{ required: true }}
            name={`forms.${index}.details`}
            render={({ field }) => (
              <TextArea
                defaultValue={field.value}
                error={errors?.forms?.[index]?.details}
                placeholder={t('feed_back.describe_serviсe') + '*'}
                onChange={(e) => {
                  field?.onChange(e?.currentTarget?.value)
                }}
              />
            )}
          />
        </div>

        <div
          className={s.item}
          key={id}
        >
          <Controller
            key={id}
            control={control}
            name={`forms.${index}.files`}
            render={({ field }) => (
              <UploadFiles
                name={id}
                files={field.value}
                error={errors?.forms?.[index]?.files as FieldError}
                onLoadFiles={(files) => {
                  field?.onChange(files)
                }}
              />
            )}
          />
        </div>
      </div>
    </Paper>
  )
}

export default SelectServiceForPassengers
